import { useLocation } from 'react-router-dom'
import { ReadGridToolbar } from '@datasets/handsontable/read-grid/readGridToolbar'
import { useAppSelector } from '@redux/hooks'
import { useQueryPendingRollupDataset } from '@templates/hooks/useQueryPending'
import { SubmissionDetailsHeader, TemplateDetailsHeader } from './components'
import * as css from './styles'
import { useDatasetDataContext } from '../datasetData/context'
import { IDatasetMetadataResponse } from '@global/api/types'

interface Props {
  datasetId: number | string
  selectedRowIndices: number[]
  removingRows: boolean
  removeRows: () => Promise<void>
  manualEditRows: () => Promise<void>
  correctErroredRows?: () => Promise<void>
  duplicateRows: () => void
  datasetRowCount: number
  shouldShowEditConfirmModal: boolean
}

export const Header = ({
  datasetId,
  selectedRowIndices = [],
  removingRows,
  removeRows,
  manualEditRows,
  correctErroredRows,
  duplicateRows,
  datasetRowCount,
  shouldShowEditConfirmModal,
}: Props) => {
  const { manualEditLoading } = useDatasetDataContext()
  const datasetMeta: IDatasetMetadataResponse | undefined = useAppSelector(
    state => state.Datasets.datasetMetadataById[datasetId] as unknown,
  ) as IDatasetMetadataResponse | undefined
  const { pendingRollupDataset } = useQueryPendingRollupDataset({
    datasetId: String(datasetId),
  })
  const location = useLocation()
  const { pathname } = location

  const isSubmissionDetailsPage = pathname.includes('/codes/')

  const manualEditDisabled =
    (selectedRowIndices.length === 0 || manualEditLoading || !datasetMeta?.id) &&
    !pendingRollupDataset?.is_pending_rollup

  if (!datasetId || !datasetMeta) return null

  return (
    <css.HeaderContainer>
      <ReadGridToolbar dataset={datasetMeta} />
      {isSubmissionDetailsPage ? (
        <SubmissionDetailsHeader
          datasetId={datasetId}
          datasetMeta={datasetMeta}
          manualEditDisabled={manualEditDisabled}
          numSelectedRows={selectedRowIndices.length}
          manualEditRows={manualEditRows}
          correctErroredRows={correctErroredRows}
          shouldShowEditConfirmModal={shouldShowEditConfirmModal}
        />
      ) : (
        <TemplateDetailsHeader
          manualEditDisabled={manualEditDisabled}
          numSelectedRows={selectedRowIndices.length}
          manualEditRows={manualEditRows}
          removeRows={removeRows}
          removingRows={removingRows}
          duplicateRows={duplicateRows}
          datasetRowCount={datasetRowCount}
          shouldShowEditConfirmModal={shouldShowEditConfirmModal}
        />
      )}
    </css.HeaderContainer>
  )
}
